import { render } from "./Tension_Trauma_Release.vue?vue&type=template&id=3042ca1a"
import script from "./Tension_Trauma_Release.vue?vue&type=script&lang=js"
export * from "./Tension_Trauma_Release.vue?vue&type=script&lang=js"
script.render = render

export default script